module.exports = __webpack_public_path__ + "img/junction-light.78ea9479.svg";